<template>
  <div class="container" v-if="selectedRankings && selectedRankings.rankings.length > 0">
    <div class="d-inline-flex ps-3 mx-auto">
      <div
          v-for="ci in challengeInfos"
          :key="ci.challenge"
          class=" rounded-top bg-sakali-primary text-light my-0 me-1 px-1 mb-0 link"
          @click="selectedRankings = rankings.find(r => r.challenge == ci.challenge)">
        <!-- rankings.map(r => r.challenge).indexOf(ci.challenge)]-->
        {{ ci.challenge | challenge }}
      </div>
    </div>
    <div>
      <div class="card-sakali mt-0 px-2" v-if="rankings.length > 0">
        <table>
          <tr v-for="rank in selectedRankings.rankings" :key="rank.teamId">
            <td>{{ rank.rank }}.</td>
            <td class="w-100">
              <cld-image
                  :publicId="'/sandkastenliga/realteams/' + rank.teamId"
                  width="17"
                  height="17"
                  crop="fill"
                  dpr="auto"
                  class="d-inline-flex align-middle"/>
              {{ rank.team }}
            </td>
            <td class="text-end">{{ rank.points }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import sakaliApi from '../../sakali-api'
import {mapActions} from 'vuex'

export default {
  props: {
    challengeInfos: Array
  },
  data() {
    return {
      rankings: [],
      selectedRankings: null
    }
  },
  methods: {
    ...mapActions(['messageAction']),
    loadRankings() {
      // https://stackoverflow.com/questions/1232040/how-do-i-empty-an-array-in-javascript
      this.rankings.length = 0;
      this.challengeInfos.forEach((ci, idx) => {
            let challenge = ci.challenge;
            sakaliApi.get('/rankings', {
              params: {
                challenge: ci.challenge,
                region: ci.region,
                round: ci.round,
                year: ci.year
              }
            }).then(response => {
              this.rankings[idx] = {challenge: challenge, rankings: response.data};
              if (idx == 0)
                this.selectedRankings = this.rankings[0];
            }).catch(error => {
              this.messageAction({
                message: error.repsponse.data,
                type: 'danger'
              })
            })
          }
      )
    }
  },
  watch: {
    challengeInfos() {
      if (this.challengeInfos.length > 0)
        this.loadRankings()
    }
  },
  mounted() {
    if (this.challengeInfos.length > 0)
      this.loadRankings()
  }
}
</script>
